/**
 * 请求方式配置
 *@author caijing
 *@date 2022/3/2 13:24
 */
export namespace ServiceOption {
  export class PostOption {
    url: string | undefined;
    responseType = 'json';
    headers = { token: '', 'Content-Type': 'application/x-www-form-urlencoded' };
    method = 'POST';
    data = {};
    transformRequest = null;
  }

  export class GetOption {
    url: string | undefined;
    responseType = 'json';
    headers = { token: '' };
    method = 'GET';
    params = {};
    paramsSerializer = null;
  }

  export class DeleteOption {
    url: string | undefined;
    responseType = 'json';
    headers = { token: '' };
    method = 'DELETE';
    params = {};
    paramsSerializer = null;
  }

  export class PutOption {
    url: string | undefined;
    responseType = 'json';
    headers = { token: '' };
    method = 'PUT';
    data = {};
    paramsSerializer = null;
  }
}
